import { apiCmo } from "./apiCmo"

const usersApi = apiCmo.injectEndpoints({
  endpoints: (builder) => ({
    getProfilesCmo: builder.query({
      query: () => "api/api/perfiles",
    }),
    getPuestosCmo: builder.query({
      query: () => "api/api/puestos",
    }),
    getZonasComercialesCmo: builder.query({
      query: () => "api/api/zonas_comerciales",
    }),
    getGerentesCmo: builder.query({
      query: () => "api/api/gerentes",
    }),
    getUserDetailCmo: builder.query({
      query: (correo) => ({
        url: "api/api/usuario",
        method: "POST",
        body: { correo },
      }),
    }),
    registerUsuarioCmo: builder.mutation({
      query: (data) => ({
        url: "api/api/registrar_usuario",
        method: "POST",
        body: data,
      }),
    }),
  }),
})

export const {
  useGetProfilesCmoQuery,
  useGetPuestosCmoQuery,
  useGetZonasComercialesCmoQuery,
  useGetGerentesCmoQuery,
  useLazyGetUserDetailCmoQuery,
  useRegisterUsuarioCmoMutation,
} = usersApi
